// 模块引入
function getModules() {
  const modulesFiles = require.context('./module', false, /\.js$/);
  const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
    const value = modulesFiles(modulePath);
    modules[moduleName] = value.default;
    return modules;
  }, {});
  return modules;
}
function getKeyVal(obj) {
  let arr = Object.keys(obj);
  return arr.reduce((before, item) => {
    Object.assign(before, obj[item]);
    return before;
  }, {});
}
const api = {
  ...getKeyVal(getModules())
};
export default api;



// WEBPACK FOOTER //
// ./src/api/api.js